// const { $ } = require("protractor");
var DateRangpicker = function () {
  $('input[name="customDateRangPicker"]').val(null);

  $('input[name="customDateRangPicker"]').daterangepicker(
    {
      autoUpdateInput: false,
      opens: "center",
      startDate: new Date(),
      endDate: new Date(),
    },
    function (start, end, label) {
      //Apply button working
      var CustomDate =
        start.format("YYYY-MM-DD") + "/" + end.format("YYYY-MM-DD");
      $('input[name="customDateRangPicker"]').val(CustomDate);
      $("#HidenCustDate").click();
    }
  );

  $('input[name="customDateRangPicker"]').on(
    "cancel.daterangepicker",
    function (ev, picker) {
      //do something, like clearing an input
      picker.startDate._d = new Date();
      picker.endDate._d = new Date();
      $('input[name="customDateRangPicker"]').val(null);
      $("#HidenCustDate").click();
    }
  );
};
